// Espagnol — couverture partielle : bloc `errors` (système de gestion des erreurs).
// Les autres namespaces retombent sur `fr` via fallbackLng.
import common from './common.json';

const es = { common };
export default es;
